import React, { Component } from "react";
import AntdAnchor, {AnchorProps} from "antd/lib/anchor";
import "antd/lib/anchor/style";

const { Link } = AntdAnchor;
export default class Anchor extends Component<AnchorProps> {
  static Link = Link;
  render() {
    return <AntdAnchor {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/anchor/index.tsx